module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "影响总览",
      "tags": ['离职 · 淘汰 · 关闭时间', '按受影响学生去重'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("统计区间")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "type": "daterange",
      "value": _vm.dateRange,
      "format": "yyyy-MM-dd",
      "clearable": false,
      "placement": "bottom-start"
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 环比口径：" + _vm._s(_vm.periodText) + " vs " + _vm._s(_vm.prevPeriodText) + "（上月同日区间）· 区间最长 93 天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("三类事件殊途同归：学生最后都得换老师。看换走了多少人、敞口多大、换完后还剩多少。同一学生被多次波及只归因到最早一起。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g21"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("老师异动事件趋势"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("截至 " + _vm._s(_vm.period.endDate || '—') + " 近 6 个月 · 按生效日 · 按类型拆分")])]), _vm._v(" "), _c('span', {
    staticClass: "chart-legend"
  }, _vm._l((_vm.typeKeys), function(t) {
    return _c('span', {
      key: t
    }, [_c('i', {
      style: ({
        background: _vm.typeColor(t)
      })
    }), _vm._v(_vm._s(_vm.typeLabel(t)))])
  }), 0)]), _vm._v(" "), (!_vm.trendCols.length) ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v("暂无数据")]) : _c('div', {
    staticClass: "cols"
  }, _vm._l((_vm.trendCols), function(col) {
    return _c('div', {
      key: col.month,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "col-total"
    }, [_vm._v(_vm._s(col.total))]), _vm._v(" "), _c('div', {
      staticClass: "col-bar",
      style: ({
        height: col.height + 'px'
      })
    }, _vm._l((col.segs), function(seg) {
      return _c('div', {
        key: seg.type,
        style: ({
          height: seg.height + 'px',
          background: seg.color
        }),
        attrs: {
          "title": seg.title
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(col.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap type-table"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.byType), function(row) {
    return _c('tr', {
      key: row.type
    }, [_c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.events)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.students)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtRate(row.switched7dRate)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.avgNoticeDays)) + _vm._s(_vm.isNum(row.avgNoticeDays) ? ' 天' : ''))])])
  }), _vm._v(" "), (!_vm.byType.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("换老师漏斗"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.eventCount)) + " 起异动 → " + _vm._s(_vm.fmtNum(_vm.funnel.students)) + " 名学生")])])]), _vm._v(" "), _c('div', {
    staticClass: "summary-strip"
  }, [_c('span', [_vm._v("未消课时敞口 "), _c('b', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.exposureHours)))]), _vm._v(" 课时")]), _vm._v(" "), _c('span', [_vm._v("超 7 天待换 "), _c('b', {
    staticClass: "is-danger"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.funnel.waitingOver7)) + " 人")])]), _vm._v(" "), _c('span', [_vm._v("换老师且改时 "), _c('b', {
    staticClass: "is-danger"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.funnel.changeSlot)) + " 人")])])]), _vm._v(" "), _vm._l((_vm.funnelRows), function(row) {
    return _c('div', {
      key: row.key,
      staticClass: "funnel-row"
    }, [_c('div', {
      staticClass: "funnel-label"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('div', {
      staticClass: "funnel-track"
    }, [_c('div', {
      staticClass: "funnel-fill",
      style: ({
        width: row.width + '%',
        background: row.color
      })
    }, [_vm._v(_vm._s(_vm.fmtNum(row.value)))])]), _vm._v(" "), _c('div', {
      staticClass: "funnel-rate"
    }, [_vm._v(_vm._s(row.rate))])])
  }), _vm._v(" "), (_vm.noticeInsight) ? _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v(_vm._s(_vm.noticeInsight))]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("损失课次看伤害深度，被波及次数看重复伤害，风险池看本周要处理的事件。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g3"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.depthRows,
      "unit": "人"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("损失课次 = 生效后 14 天应上（原周课量 × 2）− 实上，不足 14 天按已过整周折算。")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("影响频率分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.period.endDate || '—') + " 往前 90 天 · 被波及次数")])])]), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.freqRows,
      "unit": "人"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_c('b', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.repeatRate)) + " 的学生在 90 天内被波及 2 次及以上")]), _vm._v("，这批人贡献了 " + _vm._s(_vm.fmtRate(_vm.d.repeatLostShare)) + " 的损失课次，是最优先人工干预的群体。\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_vm._l((_vm.riskPool), function(row) {
    return _c('tr', {
      key: row.type + '-' + row.tchId + '-' + row.effectiveDate
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.tchName || row.tchId))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.students)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.exposureHours)))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.shortDate(row.effectiveDate)) + "\n                "), (row.effectiveDate > _vm.todayStr) ? _c('span', {
      staticClass: "t-muted"
    }, [_vm._v("未生效")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.riskPool.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("暂无待处理事件")])]) : _vm._e()], 2)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("事件与换老师")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("异动类型")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("波及学生")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("7 天换完率")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("平均通知天数")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("影响程度与风险池")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("影响程度分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("受影响学生 · 损失课次")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("待处理风险池"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("生效日在今天前 7 天 ~ 后 14 天")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("老师")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("波及学生")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("未消课时")]), _vm._v(" "), _c('th', [_vm._v("生效日")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-628bb4d5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/TchImpactOverview.vue
// module id = 1835
// module chunks = 8